export default "__VITE_ASSET__BJ0i6VQt__"